import { DebugLogger } from 'lib/debugLogger';
import { quotaCleanerDebug } from 'reactApp/appHelpers/featuresHelpers/features/quotaCleaner';
import { UserQuotaGroupId } from 'reactApp/types/QuotaCleaner';

export const widgetTitles = {
    [UserQuotaGroupId.Backup]: 'Резервные копии',
    [UserQuotaGroupId.CameraUploads]: 'Автозагрузка с телефона',
    [UserQuotaGroupId.CloudLarge]: 'Тяжёлые файлы из Облака',
    [UserQuotaGroupId.CloudOld]: 'Старые файлы',
    [UserQuotaGroupId.LargeInbox]: 'Тяжёлые входящие письма',
    [UserQuotaGroupId.LargeSent]: 'Тяжёлые отправленные письма',
    [UserQuotaGroupId.Mounted]: 'С вами поделились',
    [UserQuotaGroupId.Newsletters]: 'Рассылки',
    [UserQuotaGroupId.OldInbox]: 'Старые входящие письма',
    [UserQuotaGroupId.OldSent]: 'Старые отправленные письма',
    [UserQuotaGroupId.Read]: 'Прочитанные письма',
    [UserQuotaGroupId.MailBin]: 'Корзина Почты',
    [UserQuotaGroupId.MailSpam]: 'Спам Почты',
    [UserQuotaGroupId.Video]: 'Видео',
    [UserQuotaGroupId.WithAttaches]: 'Письма с вложениями',
    [UserQuotaGroupId.CloudBin]: 'Корзина Облака',
};

export const baseItemsLimit = 4;
export const imageItemsLimit = 18;

export const quotaCleanerRlog = 'cloud-quota-cleaner';
export const quotaCleanerFastRlog = 'cloud-quota-cleaner-fast';

export const letterDefaultName = '<Без темы>';

export const letterGroups = [
    UserQuotaGroupId.LargeInbox,
    UserQuotaGroupId.LargeSent,
    UserQuotaGroupId.Newsletters,
    UserQuotaGroupId.OldInbox,
    UserQuotaGroupId.OldSent,
    UserQuotaGroupId.Read,
    UserQuotaGroupId.WithAttaches,
    UserQuotaGroupId.MailBin,
    UserQuotaGroupId.MailSpam,
];

export const cloudGroups = [
    UserQuotaGroupId.Mounted,
    UserQuotaGroupId.Backup,
    UserQuotaGroupId.CloudLarge,
    UserQuotaGroupId.CloudOld,
    UserQuotaGroupId.Video,
    UserQuotaGroupId.CameraUploads,
    UserQuotaGroupId.CloudBin,
];

export const yearFilterGroups = [UserQuotaGroupId.OldInbox, UserQuotaGroupId.OldSent, UserQuotaGroupId.CloudOld];

export const removableGroupsIds = [UserQuotaGroupId.MailSpam, UserQuotaGroupId.MailBin, UserQuotaGroupId.CloudBin];

export const quotaCleanerDebugLogger = new DebugLogger({ DEBUG_SCOPE: 'QuotaCleaner', DEBUG: quotaCleanerDebug });

// для аналитики
export const quotaCleanerEntryPoint = {
    landing: 'fast_clean_landing',
    directLink: 'fast_clean_direct_link',
    instant: 'fast_clean_inst',
    cta: (ctaId: string, expId: string) => `fast_clean_${ctaId}_${expId}`,
    ctaInstant: (ctaId: string, expId: string) => `fast_clean_inst_${ctaId}_${expId}`,
};
